import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const mutationPlaidLinkTokenGenerateAtom = createMutationAtomFactory(
  'finance.plaidLinkTokenGenerate',
  (_: void) => ({
    integrationsPlaidCreateLinkToken: {
      expiresAt: true,
      token: true,
    },
  }),
);
